import { commonResourceFormFieldDescriptors } from "~/domain/common";
import { LqsFiltersSidebar, processStateOptions } from "~/lqs";
import { listDigestionsSchema } from "../schemas";
import { useDigestionSearchRequest } from "./DigestionTable";

export function DigestionFilters() {
  const [request, setRequest] = useDigestionSearchRequest();

  return (
    <LqsFiltersSidebar
      registryKey="digestion"
      request={request}
      setRequest={setRequest}
      schema={listDigestionsSchema}
      descriptors={[
        { name: "id", type: "text" },
        { name: "name", type: "fuzzy", fuzzyName: "nameLike" },
        { name: "logId", type: "foreign-key", resourceType: "log" },
        { name: "workflowId", type: "foreign-key", resourceType: "workflow" },
        { name: "workflowIdNull", type: "boolean" },
        { name: "state", type: "select", options: processStateOptions },
        { name: "noteLike", type: "text", label: "Note" },
        { name: "progressGte", type: "number" },
        { name: "progressLte", type: "number" },
        { name: "progressNull", type: "boolean" },
        ...commonResourceFormFieldDescriptors,
      ]}
    />
  );
}
